import React from 'react';
import { TECHNIQUES } from '../siteNav';
import { PageHero, PageShell, QuoteButton } from '../components/site/PageParts';
import useSeo from '../hooks/useSeo';

const STARTING_PRICES = [
  { item: 'Screen-printed tees', price: 'From $8 each at 100 pieces' },
  { item: 'Embroidered hats', price: 'From $25 each at 50 pieces' },
  { item: 'DTF printing', price: 'Prices vary' },
  { item: 'DTG printing', price: 'Prices vary' },
];

function PriceTable({ title, rows, testid, note }) {
  return (
    <section className="px-6 py-6" data-testid={testid}>
      <div className="max-w-[1400px] mx-auto rounded-xl border border-white/10 overflow-hidden">
        <h2 className="font-display text-[#f4efe6] uppercase text-2xl md:text-3xl tracking-tight p-8 pb-4">{title}</h2>
        <table className="w-full text-left">
          <tbody>
            {rows.map(([label, value, id]) => (
              <tr key={label} className="border-t border-white/10 flex flex-col sm:table-row" data-testid={`${testid}-${id}`}>
                <td className="px-8 pt-4 pb-1 sm:py-4 text-[#f4efe6]">{label}</td>
                <td className="px-8 pb-4 pt-0 sm:py-4 text-[#00b8ff] font-semibold sm:text-right">{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {note && <p className="px-8 py-5 border-t border-white/10 text-[#cfc8bb]" data-testid={`${testid}-note`}>{note}</p>}
      </div>
    </section>
  );
}

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');

export default function Pricing() {
  useSeo({
    title: 'Pricing | Merch Production | Pusha Teez',
    description:
      'Merch production pricing from Pusha Teez: screen-printed tees from $8 each at 100 pieces, embroidered hats from $25 each at 50 pieces. Low minimums. Every order is quoted individually.',
    path: '/pricing',
  });
  return (
    <PageShell testid="pricing-page">
      <PageHero
        eyebrow="Pricing"
        title="Production"
        accent="Pricing"
        intro="Starting prices, minimums and rush fees for merch produced in-house in Los Angeles / Orange County."
      />
      <PriceTable title="Starting at" testid="pricing-start" rows={STARTING_PRICES.map((p) => [p.item, p.price, slug(p.item)])} />
      <PriceTable
        title="Minimums by technique"
        testid="pricing-min"
        rows={TECHNIQUES.filter((t) => !t.quotedPerProject).map((t) => [t.name, t.minimum || 'No minimum', t.slug])}
        note="Graphic design is quoted per project."
      />
      <PriceTable title="Rush fees" testid="pricing-rush" rows={[['Orders needed in under 3 days', '$200', 'under-3-days']]} />
      <section className="px-6 py-20" data-testid="pricing-closing">
        <div className="max-w-[1400px] mx-auto rounded-2xl border border-white/10 bg-gradient-to-br from-[#00b8ff]/15 to-transparent p-10 md:p-16 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <p className="font-display text-[#f4efe6] uppercase text-2xl md:text-4xl tracking-tight leading-tight max-w-3xl">
            Every order is quoted individually — prices depend on garment, colors, locations and quantity.
          </p>
          <QuoteButton testid="pricing-quote-btn" />
        </div>
      </section>
    </PageShell>
  );
}
